/*!
 *
 * accordion.js
 *
 */

const defo = {
	head: '.head',
	currentClass: '.current',
	expandClass: '.expanded'
}

const accordion = function( _this, options ){
	this.setting = $.extend({}, defo, options);
	this.$elem = $(_this);
	this.$head = this.$elem.find( this.setting.head );
	this.init();
};

accordion.prototype = {
	init: function(){
		var self = this;

		this.setHeight();
		this.$head.each(function(){
			let $target = $( $(this).attr('href') );
			$target.css('max-height', 0);
		});

		this.$head.on('tap', function(e){
			e.preventDefault();
			let $target = $( $(this).attr('href') );
			$(this).toggleClass( self.setting.currentClass );
			$target.toggleClass( self.setting.expandClass );
			let h = 0;
			if( $target.is('.'+self.setting.expandClass) ){
				h = $target.data('height');
				console.log(h)
			};
			$target.css('max-height', h);
		});

		origin.$window.on('resize', function(){
			self.setHeight();
		});
	},
	setHeight: function(){
		this.$head.each(function(){
			let $target = $( $(this).attr('href') );
			let h = $target.children().outerHeight();
			$target.data('height', h);
		});
	}
};

$.fn.accordion = function(options) {
	return this.each(function() {
		new accordion(this, options);
	});
};


//////////////////
// WEBPACK FOOTER
// ./dev/js/module/accordion.js
// module id = 18
// module chunks = 0